import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

/**
 * Any block can take a turn in a slot, so nothing is restricted here — a slot
 * of images is a logo wall, a slot of paragraphs is a swapping word.
 *
 * The frontend stacks these children on one grid cell. The canvas lays them
 * out in a column instead, sharing the parent's --static class so there is one
 * static layout to maintain rather than two.
 */
export default function Edit() {
	const blockProps = useBlockProps( {
		className: 'brandy-rotator-slot',
	} );

	const innerBlocksProps = useInnerBlocksProps( blockProps, {
		templateLock: false,
	} );

	return <div { ...innerBlocksProps } />;
}
